import React from "react";
import Autocompete from './Autocompete'
// import Checkbox from '@mui/material/Checkbox';
// import Select, { SelectChangeEvent } from '@mui/material/Select';

// function BasicSelect() {
//   const [age, setAge] = React.useState('');

//   const handleChange = (event: SelectChangeEvent) => {
//     setAge(event.target.value as string);
//   }}
//import Job from './Job.js'
import { Link } from 'react-router-dom'
import "./Recruitment.css";
import {
  Typography,
  TextField,
  InputAdornment,
  Button,
  Autocomplete,
  Checkbox,
  FormControl,
  MenuItem,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Box,
  Select,
} from "@material-ui/core";
import './JobProcess.css';
import JobHeader from './JobHeader'
import SideBar from './SideBar'

   
export default function Recruitment() {
  return (
    <> 
    <JobHeader/>
    <div class ="jobProcess">
        <SideBar/>
    <div class="rec">
      <h1>Recruiting Details</h1>
      <br/>
      <div className="field-hd">Number of Openings</div> <br />
      <input type="Number" className="text_name" />
      <br />
      <div className="field-hd"> Reason <span className="mandatory">*</span></div> 
      <br />
      <div className="field-hd"> Spotlight Job</div> 
      <FormGroup>
        <FormControlLabel control={<Checkbox defaultChecked />} label="" />
      </FormGroup>
      <br />
      <div className="field-hd">Replacement For</div> 
      <Autocompete/>
      <br />
      <Box sx={{ minWidth: 120 }}>
      <div className="field-hd">Recruiting Instruction</div> 
     
      <div className="Rec-instr">
        <FormControl fullWidth>
          {/* <InputLabel id="demo-simple-select-label">Select one</InputLabel> */}
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            //   value={age}
            //   label="Age"
            //   onChange={handleChange}
          >
            <MenuItem value={10}>Post External only</MenuItem>
            <MenuItem value={20}>Posting Not Required</MenuItem>
            <MenuItem value={30}>Post Internal and External</MenuItem>
            <MenuItem value={30}>
              Post Internally for two weeks before posting external
            </MenuItem>
            <MenuItem value={30}>Post Internal only</MenuItem>
          </Select>
        </FormControl>
      </div>
      </Box>
      <div className="field-hd">Recruiting Start Date <span className="mandatory">*</span></div> 
    
      <TextField
        id="date"
        type="date"
        style={{ padding: "10px", color: "black" }}
        defaultValue="YYYY/MM/DD"
        InputLabelProps={{
          shrink: true,
        }}
      />
      <br />
      <div className="field-hd">Target Hire Date <span className="mandatory">*</span></div>
      
      <TextField
        id="date"
        type="date"
        style={{ padding: "10px", color: "black", width:"300px" }}
        defaultValue="YYYY/MM/DD"
        InputLabelProps={{
          shrink: true,
        }}
      />{" "}
     <br/>
      <div className="field-hd"> Target end Date <br /></div>
      <TextField
        id="date"
        type="date"
        style={{ padding: "10px", color: "black" , width:"300px"}}
        defaultValue="YYYY/MM/DD"
        InputLabelProps={{
          shrink: true,
        }}
      /><br/>
      <div className="field-hd1"><h2>Referral Details</h2></div>
      <div className="field-hd">Referral Payement plans</div>
      <Autocompete/>

      <br/>
      </div>
      </div>
      <div className='next-bar'>
    <button className='back-btn'>Back</button>
   <Link to="/job"> <button className='next-btn'>Next</button></Link>
          
        </div></>
  );
}
